/* ---- dynamic dates / estimated shipping ---- */
class DynamicDates extends HTMLElement {
  constructor() {
    super();
    this.dateFormat = this.dataset.dateFormat;
    this.days = this.rearrangeDays(this.dataset.dayLabels.split(","));
    this.months = this.dataset.monthLabels.split(",");
    this.elementsToChange = this.querySelectorAll("[data-dynamic-date=\"true\"]");
    this.daysToSkip = this.parseDaysToSkip(this.dataset.daysToSkip || "");
    this.datesToSkip = this.parseDatesToSkip(this.dataset.datesToSkip || "");
    this.insertDates();
    checkDateValidity(currentDate);
    document.addEventListener("shopify:section:load", t => {
      this.insertDates();
    });
  }
  addDaysSkipping($, t) {
    let x = new Date($);
    let e = Number(t) || 0;
    while (e > 0) {
      x = addDays(x, 1);
      if (!this.isSkipped(x)) {
        e--;
      }
    }
    return x;
  }
  parseDaysToSkip($) {
    let x = new Map([["sunday", 0], ["monday", 1], ["tuesday", 2], ["wednesday", 3], ["thursday", 4], ["friday", 5], ["saturday", 6]]);
    let e = new Set();
    if ($) {
      $.split(",").forEach($ => {
        let s = $.trim();
        if (x.has(s)) {
          e.add(x.get(s));
        }
      });
    }
    return e;
  }
  parseDatesToSkip($) {
    let x = new Set();
    if ($) {
      $.split(",").forEach($ => {
        let i = $.trim();
        if (!i) {
          return;
        }
        let s = i.split("-");
        if (s.length === 2) {
          let a = String(Math.max(1, Math.min(12, Number(s[0])))).padStart(2, "0");
          let r = String(Math.max(1, Math.min(31, Number(s[1])))).padStart(2, "0");
          x.add(a + "-" + r);
        } else if (s.length === 3) {
          let n = String(Math.max(1, Math.min(12, Number(s[1])))).padStart(2, "0");
          let l = String(Math.max(1, Math.min(31, Number(s[2])))).padStart(2, "0");
          x.add(n + "-" + l);
        }
      });
    }
    return x;
  }
  isSkipped($) {
    let x = this.daysToSkip.has($.getDay());
    let e = String($.getMonth() + 1).padStart(2, "0");
    let i = String($.getDate()).padStart(2, "0");
    let s = this.datesToSkip.has(e + "-" + i);
    return x || s;
  }
  nextValidDate($) {
    let x = new Date($);
    while (this.isSkipped(x)) {
      x = addDays(x, 1);
    }
    return x;
  }
  insertDates() {
    this.elementsToChange.forEach($ => {
      let x = $.dataset.text;
      let e = parseInt($.dataset.minDays);
      let i = parseInt($.dataset.maxDays);
      let s = this.addDaysSkipping(currentDate, e);
      let a = this.addDaysSkipping(currentDate, i);
      let r = "th";
      let n = s.getDate();
      if ([1, 21, 31].includes(n)) {
        r = "st";
      } else if ([2, 22].includes(n)) {
        r = "nd";
      } else if ([3, 23].includes(n)) {
        r = "rd";
      }
      let l = "th";
      let h = a.getDate();
      if ([1, 21, 31].includes(h)) {
        l = "st";
      } else if ([2, 22].includes(h)) {
        l = "nd";
      } else if ([3, 23].includes(h)) {
        l = "rd";
      }
      let c;
      let d;
      if (this.dateFormat === "day_dd_mm") {
        c = this.days[s.getDay()] + ", " + s.getDate() + ". " + this.months[s.getMonth()];
        d = this.days[a.getDay()] + ", " + a.getDate() + ". " + this.months[a.getMonth()];
      } else if (this.dateFormat === "mm_dd") {
        c = this.months[s.getMonth()] + " " + s.getDate() + r;
        d = this.months[a.getMonth()] + " " + a.getDate() + l;
      } else if (this.dateFormat === "dd_mm") {
        c = s.getDate() + ". " + this.months[s.getMonth()];
        d = a.getDate() + ". " + this.months[a.getMonth()];
      } else if (this.dateFormat === "dd_mm_no_dot") {
        c = s.getDate() + " " + this.months[s.getMonth()];
        d = a.getDate() + " " + this.months[a.getMonth()];
      } else if (this.dateFormat === "day_dd_mm_numeric") {
        let o = String(s.getDate()).padStart(2, "0");
        let f = String(s.getMonth() + 1).padStart(2, "0");
        c = this.days[s.getDay()] + ", " + o + ". " + f + ".";
        let u = String(a.getDate()).padStart(2, "0");
        let b = String(a.getMonth() + 1).padStart(2, "0");
        d = this.days[a.getDay()] + ", " + u + ". " + b + ".";
      } else if (this.dateFormat === "dd_mm_numeric") {
        let p = String(s.getDate()).padStart(2, "0");
        let _ = String(s.getMonth() + 1).padStart(2, "0");
        c = p + ". " + _ + ".";
        let m = String(a.getDate()).padStart(2, "0");
        let y = String(a.getMonth() + 1).padStart(2, "0");
        d = m + ". " + y + ".";
      } else {
        c = this.days[s.getDay()] + ", " + this.months[s.getMonth()] + " " + s.getDate() + r;
        d = this.days[a.getDay()] + ", " + this.months[a.getMonth()] + " " + a.getDate() + l;
      }
      let g = x.replace("[start_date]", c);
      let v = g.replace("[end_date]", d);
      $.innerHTML = v;
    });
  }
  rearrangeDays($) {
    $.unshift($[6]);
    $.length = 7;
    return $;
  }
}
customElements.define("dynamic-dates", DynamicDates);
